import { combineReducers } from 'redux';
import schedule from './slices/schedule';

const controlReducer = combineReducers({
  schedule,
});

export default controlReducer;
